import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import city1 from "../../assest/slider/bg12.jpg";
import city2 from "../../assest/slider/bg8.jpg";
import city3 from "../../assest/slider/bg3.jpg";

const images = [city1, city2, city3];

const AboutUs = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval);
  }, []);


  return (
    <section
      className="about-us"
      style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
    >
      {/* Arrow Buttons */}
      <button type="button" className="arrow left-arrow" onClick={prevImage}>
        &#8592;
      </button>
      <button type="button" className="arrow right-arrow" onClick={nextImage}>
        &#8594;
      </button>


      {/* Image Content */}
      {currentImageIndex === 0 && (
        <>
          <h2>Welcome to Proscope</h2>
          <p>The best choice of your technology consultant</p>
          <div className="buttons">
            <button
              className="check-now"
              onClick={() => (window.location.href = "/aboutus")}
            >
              CHECK NOW
            </button>
          </div>
        </>
      )}
      {currentImageIndex === 1 && (
        <>
          <h2>We are Dell Preferred Partner</h2>
          <p>Listen. Learn. Deliver. Provide the best support for customer.</p>
          <div className="buttons">
            <button
              className="check-now"
              onClick={() => (window.location.href = "/allproduct")}
            >
              CHECK NOW
            </button>
          </div>
        </>
      )}
      {currentImageIndex === 2 && (
        <>
          <h2>Presentations2Go</h2>
          <p>The best classroom capturing solution</p>
          <div className="buttons">
            <button className="check-now">CHECK NOW</button>
            <a href="https://demo.presentations2go.eu/P2G/cataloguepage.aspx">
              <button className="live-demo">LIVE DEMO</button>
            </a>
          </div>
        </>
      )}

      <div className="image-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentImageIndex ? "active" : ""}`}
            onClick={() => setCurrentImageIndex(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default AboutUs;
